<!--
 * @Author: zl
 * @Date: 2022-02-17 17:49:41
 * @LastEditTime: 2022-03-14 17:15:56
 * @LastEditors: zl
 * @Description: 报表管理
-->
<template>
	<el-tabs type="card"
			 class="full-tabs FormManager-layout card-tabs"
			 v-model="activeTab"
			 @tab-click="tabClick">
		<template v-for="(item,index) in tabArr">
			<el-tab-pane :key="item.field"
						 :label="item.label"
						 :name="index + 1 + ''">
				<div class="filter-layout">
					<!-- 筛选搜索栏 -->
					<div class="filter-box">
						<el-form ref="elForm"
								 :model="searchObj"
								 label-width="140px"
								 size="small">
							<el-row>
								<el-col :span="8">
									<el-form-item label="时间维度"
												  label-width="120px"
												  prop="selectDateType">
										<el-button-group class="btn-flex">
											<el-button v-for="(item, index) in btnGroup"
													   :key="item.type"
													   :type="activeBtn === index ? 'primary' : ''"
													   @click="radioChange(item.type, index)">
												{{ item.btnName }}
											</el-button>
										</el-button-group>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<template v-if="activeBtn === 0">
										<el-form-item label="选择月份"
													  prop="selectDate">
											<el-date-picker v-model="searchObj.selectDate"
															type="monthrange"
															@change="monthChange($event, 'selectDate')"
															range-separator="~"
															start-placeholder="开始日期"
															end-placeholder="结束日期"
															value-format="yyyy-MM"
															placeholder="请选择...">
											</el-date-picker>
										</el-form-item>
									</template>
									<template v-if="activeBtn === 1">
										<el-form-item label="选择季度"
													  prop="selectDate">
											<div class="flex">
												<el-select v-model="searchObj.selectStartTime"
														   placeholder="请选择..."
														   clearable
														   @change="quarterChange($event, 'start')">
													<el-option v-for="item in quarterList"
															   :key="'start' + item.id"
															   :label="item.year + '年' + item.quarter + '季度'"
															   :value="item.quarterStartTime">
													</el-option>
												</el-select>
												<span class="ml5 mr5">~</span>
												<el-select v-model="searchObj.selectEndTime"
														   placeholder="请选择..."
														   clearable
														   @change="quarterChange($event, 'end')">
													<el-option v-for="item in quarterList"
															   :key="'end' + item.id"
															   :label="item.year + '年' + item.quarter + '季度'"
															   :value="item.quarterEndTime">
													</el-option>
												</el-select>
											</div>
										</el-form-item>
									</template>
									<template v-if="activeBtn === 2">
										<el-form-item label="选择年份"
													  prop="selectDate">
											<div class="flex">
												<el-date-picker v-model="searchObj.selectStartTime"
																type="year"
																placeholder="请选择..."
																value-format="yyyy"
																@change="yearChange($event, 'start')">
												</el-date-picker>
												<span class="ml5 mr5">~</span>
												<el-date-picker v-model="searchObj.selectEndTime"
																type="year"
																placeholder="请选择..."
																value-format="yyyy"
																@change="yearChange($event, 'end')">
												</el-date-picker>
											</div>

										</el-form-item>
									</template>
								</el-col>
								<el-col :span="8">
									<el-form-item label="项目名称"
												  prop="projectName">
										<el-input v-model="searchObj.projectName"
												  placeholder="请输入..."></el-input>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="8">
									<el-form-item label="建设单位"
												  label-width="120px"
												  prop="ownerUnitName">
										<el-input v-model="searchObj.ownerUnitName"
												  placeholder="请输入..."></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="协审单位"
												  prop="assistantUnitName">
										<el-input v-model="searchObj.assistantUnitName"
												  placeholder="请输入..."></el-input>
									</el-form-item>
								</el-col>
								<template v-if="item.field == 'notice'">
									<el-col :span="8">
										<el-form-item label="协审单位确定日期"
													  prop="acceptDate">
											<el-date-picker v-model="searchObj.acceptDate"
															@change="monthChange($event, 'acceptDate')"
															value-format="yyyy-MM"
															type="monthrange"
															range-separator="~"
															start-placeholder="开始日期"
															end-placeholder="结束日期"
															placeholder="请选择..."></el-date-picker>
										</el-form-item>
									</el-col>
								</template>
								<template v-if="item.field == 'success'">
									<el-col :span="8">
										<el-form-item label="审定日期"
													  prop="auditDate">
											<el-date-picker v-model="searchObj.auditDate"
															@change="monthChange($event, 'auditDate')"
															value-format="yyyy-MM"
															type="monthrange"
															range-separator="~"
															start-placeholder="开始日期"
															end-placeholder="结束日期"
															placeholder="请选择..."></el-date-picker>
										</el-form-item>
									</el-col>
								</template>
								<template v-if="item.field == 'pay'">
									<el-col :span="8">
										<el-form-item label="费用申请日期"
													  prop="applyDate">
											<el-date-picker v-model="searchObj.applyDate"
															@change="monthChange($event, 'applyDate')"
															value-format="yyyy-MM"
															type="monthrange"
															range-separator="~"
															start-placeholder="开始日期"
															end-placeholder="结束日期"
															placeholder="请选择..."></el-date-picker>
										</el-form-item>
									</el-col>
								</template>
								<template v-if="item.field == 'money'">
									<el-col :span="8">
										<el-form-item label="归档日期"
													  prop="archiveDate">
											<el-date-picker v-model="searchObj.archiveDate"
															@change="monthChange($event, 'archiveDate')"
															value-format="yyyy-MM"
															type="monthrange"
															range-separator="~"
															start-placeholder="开始日期"
															end-placeholder="结束日期"
															placeholder="请选择..."></el-date-picker>
										</el-form-item>
									</el-col>
								</template>
							</el-row>
							<el-row>
								<template v-if="item.field == 'pay'">
									<el-col :span="8">
										<el-form-item label="费用审批日期"
													  label-width="120px"
													  prop="approveDate">
											<el-date-picker v-model="searchObj.approveDate"
															@change="monthChange($event, 'approveDate')"
															value-format="yyyy-MM"
															type="monthrange"
															range-separator="~"
															start-placeholder="开始日期"
															end-placeholder="结束日期"
															placeholder="请选择..."></el-date-picker>
										</el-form-item>
									</el-col>
								</template>
								<el-col :span="item.field == 'pay' ? 8 : 16">
									<el-form-item label="当前筛选时间：">
										<span>{{ startText }}</span>
										<span v-if="startText != '' || endText != ''"
											  class="ml5 mr5">至</span>
										<span>{{ endText }}</span>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item class="text-right">
										<el-button type="primary"
												   icon="el-icon-search"
												   @click="searchResult">查询</el-button>
										<el-button icon="el-icon-refresh"
												   @click="refreshResult(index)">重置</el-button>
									</el-form-item>
								</el-col>
							</el-row>
						</el-form>
					</div>
					<!-- 具体内容 -->
					<div class="filter-content"
						 v-show="tableShow">
						<TaskStatement v-if="item.field == 'notice' && activeTab == index + 1"
									   ref="tableData"
									   :searchObj="searchObj"
									   :activeTab="activeTab"
									   :startText="startText"
									   :endText="endText"
									   @acceptId="acceptId"></TaskStatement>
						<SuccessStatement v-if="item.field == 'success' && activeTab == index + 1"
										  ref="tableData"
										  :searchObj="searchObj"
										  :activeTab="activeTab"
										  :startText="startText"
										  :endText="endText"
										  @acceptId="acceptId"></SuccessStatement>
						<PayStatement v-if="item.field == 'pay' && activeTab == index + 1"
									  ref="tableData"
									  :searchObj="searchObj"
									  :activeTab="activeTab"
									  :startText="startText"
									  :endText="endText"
									  @acceptId="acceptId"></PayStatement>
						<MoneyStatement v-if="item.field == 'money' && activeTab == index + 1"
										ref="tableData"
										:searchObj="searchObj"
										:activeTab="activeTab"
										:startText="startText"
										:endText="endText"
										@acceptId="acceptId"></MoneyStatement>

					</div>
				</div>
			</el-tab-pane>
		</template>
		<!-- 查看标段信息 -->
		<SectionLook v-if="sectionShow"
					 ref="SectionLook"
					 :sectionId="sectionId"></SectionLook>
	</el-tabs>
</template>
<script>
import { mapState } from 'vuex'
import * as API from 'api/FormManager/FormManager'
import * as HomeApi from 'api/home/homeIndex'
import TaskStatement from '@/views/FormManager/components/TaskStatement'
import SuccessStatement from '@/views/FormManager/components/SuccessStatement'
import PayStatement from '@/views/FormManager/components/PayStatement'
import MoneyStatement from '@/views/FormManager/components/MoneyStatement'
import SectionLook from '@/views/Common/SectionLook'
export default {
	name: 'FormManager',
	components: {
		TaskStatement,
		SuccessStatement,
		PayStatement,
		MoneyStatement,
		SectionLook,
	},
	data() {
		return {
			activeTab: '1', //tab激活
			copySearchObj: {}, //备份注释对象
			searchObj: {
				projectName: '', //项目名称
				ownerUnitName: '', //建设单位
				assistantUnitName: '', //协审单位
				isNorth: [], //南北区 多选逗号分割 0,1
				entrust: ['0', '1'], //委托方 多选逗号分割 0,1
				auditType: ['1006004001', '1006004002'], //审计任务类型 多选逗号分割 1006004001,1006004002
				selectDateType: '1', //选择时间类型 1 按月 2 按季度 3 按年
				selectDate: [],
				selectStartTime: '', //时间维度开始时间
				selectEndTime: '', //时间维度结束时间
				archiveDate: [],
				archiveStartTime: '', //归档开始时间
				archiveEndTime: '', //归档结束时间
				auditDate: [],
				auditStartTime: '', //审定开始日期
				auditEndTime: '', //审定结束日期
				acceptDate: [],
				acceptStartTime: '', //协审单位确定开始日期
				acceptEndTime: '', //协审单位确定结束日期
				approveDate: [], //
				feeApproveStartTime: '', //费用审批开始日期
				feeApproveEndTime: '', //费用审批开始日期
				applyDate: [],
				feeApplyStartTime: '', //费用申请开始日期
				feeApplyEndTime: '', //费用申请结束日期
			},
			sectionShow: false,
			sectionId: '', //标段id
			quarterList: [], //季度列表
			activeBtn: 0, //当前选择的时间维度
			copyDate: '', //备份的当前时间
			tableShow: true, // 处理table 视图变化
			startText: '', //开始时间文字
			endText: '', //结束时间文字
		}
	},
	created() {
	  //动态默认勾选片区操作
    var ar=[];
	  var arr=this.projectDict.xmgsqy;
    for (var obj of arr){
      ar.push(obj.value)
    }
    this.searchObj.isNorth=ar;
		this.copySearchObj = this.$utils.clone(this.searchObj, true)
		// 获取当前时间
		this.getNowDate()
		// 获取季度
		this.getJd()
		if (this.$getSessionItem('activeTab')) {
			this.activeTab = JSON.parse(this.$getSessionItem('activeTab'))
			this.$removeSessionItem('activeTab')
		}
		if (this.$getSessionItem('last')) {
			if (JSON.parse(this.$getSessionItem('last'))) {
				this.tabClick({
					label: '审核产值报表',
				})
			}
			this.$removeSessionItem('last')
		}
	},
	methods: {
		// 获取当前时间
		getNowDate() {
			HomeApi.getContainerParams({}).then((res) => {
				let searchDate = res.data.currentDate.substr(0, 7)
				this.searchObj.selectDate = [searchDate, searchDate]
				this.searchObj.selectStartTime = searchDate
				this.searchObj.selectEndTime = searchDate
				this.searchResult()
			})
		},

		// 获取季度
		getJd() {
			API.getQuarterData().then((res) => {
				this.quarterList = res.data.quarterList
			})
		},

		// 时间维度点击事件
		radioChange(type, index) {
			this.activeBtn = index
			this.searchObj.selectStartTime = ''
			this.searchObj.selectEndTime = ''
			this.searchObj.selectDate = []
			switch (type) {
				case 'month':
					this.searchObj.selectDateType = '1'
					break
				case 'quarter':
					this.searchObj.selectDateType = '2'
					break
				case 'year':
					this.searchObj.selectDateType = '3'
					break
			}
		},

		// 年份选择change
		yearChange(data, type) {
			if (type == 'start') {
				let endTime = this.searchObj.selectEndTime || 0
				if (
					parseInt(data) > parseInt(endTime) &&
					parseInt(endTime) != 0
				) {
					this.searchObj.selectStartTime = ''
					this.$message.error('开始时间不能超过结束时间！')
				}
				return
			}
			let startTime = this.searchObj.selectStartTime || 0
			if (parseInt(data) < parseInt(startTime)) {
				this.searchObj.selectEndTime = ''
				this.$message.error('结束时间不能小于开始时间！')
			}
		},

		// 季度选择change
		quarterChange(data, type) {
			if (data == '') {
				return
			}
			if (type == 'start') {
				let endTime = this.searchObj.selectEndTime
				let handlerData = this.quarterList.find(
					(x) => x.quarterStartTime == data
				)
				if (endTime != '') {
					let handlerEndData = this.quarterList.find(
						(x) => x.quarterEndTime == endTime
					)
					if (handlerData.id > handlerEndData.id) {
						this.searchObj.selectStartTime = ''
						this.$message.error('开始季度不能超过结束季度！')
					}
				}
				return
			}
			let startTime = this.searchObj.selectStartTime
			let handlerData = this.quarterList.find(
				(x) => x.quarterEndTime == data
			)
			if (startTime != '') {
				let handlerEndData = this.quarterList.find(
					(x) => x.quarterStartTime == startTime
				)
				if (handlerData.id < handlerEndData.id) {
					this.searchObj.selectEndTime = ''
					this.$message.error('结束季度不能小于开始季度！')
				}
			}
		},

		// 月份change事件
		monthChange(data, type) {
			switch (type) {
				case 'selectDate':
					this.searchObj.selectStartTime = data?.[0] || ''
					this.searchObj.selectEndTime = data?.[1] || ''
					break
				case 'acceptDate':
					this.searchObj.acceptStartTime = data?.[0] || ''
					this.searchObj.acceptEndTime = data?.[1] || ''
					break
				case 'auditDate':
					this.searchObj.auditStartTime = data?.[0] || ''
					this.searchObj.auditEndTime = data?.[1] || ''
					break
				case 'archiveDate':
					this.searchObj.archiveStartTime = data?.[0] || ''
					this.searchObj.archiveEndTime = data?.[1] || ''
					break
				case 'approveDate':
					this.searchObj.feeApproveStartTime = data?.[0] || ''
					this.searchObj.feeApproveEndTime = data?.[1] || ''
					break
				case 'applyDate':
					this.searchObj.feeApplyStartTime = data?.[0] || ''
					this.searchObj.feeApplyEndTime = data?.[1] || ''
					break
			}
		},

		// 清除月份相关信息
		claerMonth() {
			this.searchObj.acceptStartTime = ''
			this.searchObj.acceptEndTime = ''
			this.searchObj.auditStartTime = ''
			this.searchObj.auditEndTime = ''
			this.searchObj.archiveStartTime = ''
			this.searchObj.archiveEndTime = ''
			this.searchObj.selectStartTime = ''
			this.searchObj.selectEndTime = ''
			this.searchObj.feeApproveStartTime = ''
			this.searchObj.feeApproveEndTime = ''
			this.searchObj.feeApplyStartTime = ''
			this.searchObj.feeApplyEndTime = ''
		},

		// tab点击事件
		tabClick(data) {
			this.searchObj = this.$utils.clone(this.copySearchObj, true)
			if (data.label == '审核产值报表') {
				this.searchObj.auditType = ['1006004001']
			}
			this.activeBtn = 0
			setTimeout(() => {
				// 获取当前时间
				this.getNowDate()
			}, 200)
		},

		// 查询按钮点击事件
		searchResult() {
			this.$refs.tableData[0].tableObj.currentPage = 1
			this.$refs.tableData[0].getStatementData()
		},

		// 重置按钮点击事件
		refreshResult(index) {
			this.$set(this.searchObj, 'selectDateType', '1')
			this.claerMonth()
			this.activeBtn = 0
			this.$refs.elForm[index].resetFields()
			this.startText = ''
			this.endText = ''
			// 获取当前时间
			this.getNowDate()
		},

		// 接收标段id
		acceptId(data) {
			this.sectionShow = true
			this.sectionId = data.packId
			setTimeout(() => {
				this.$refs.SectionLook.dialogObj.show = true
			}, 200)
		},
	},
	computed: {
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
		...mapState('app', {
			clientSize: (state) => state.clientSize,
		}),
    ...mapState('dict', {
      projectDict: (state) => state.projectDict,
    }),
		// 时间维度按钮
		btnGroup() {
			let arr = [
				{
					btnName: '按月份',
					type: 'month',
				},
				{
					btnName: '按季度',
					type: 'quarter',
				},
				{
					btnName: '按年份',
					type: 'year',
				},
			]
			return arr
		},

		// tab
		tabArr() {
			let arr = [
				{
					label: '审计任务委托报表',
					show: this.roleBtns.includes('notice_task_statement'),
					field: 'notice',
				},
				{
					label: '审计任务完成报表',
					show: this.roleBtns.includes('statement_success'),
					field: 'success',
				},
				{
					label: '请/付款报表',
					show: this.roleBtns.includes('pay_statement'),
					field: 'pay',
				},
				{
					label: '审核产值报表',
					show: this.roleBtns.includes('money_statement'),
					field: 'money',
				},
			]
			arr = arr.filter((x) => x.show)

			return arr
		},
	},
	watch: {
		// 监听视图
		clientSize() {
			this.tableShow = false

			setTimeout(() => {
				this.tableShow = true
			}, 50)
		},
		'searchObj.selectStartTime': {
			handler(newVal, oldVal) {
				this.startText = ''
				if (newVal == '') {
					return
				}
				switch (this.activeBtn) {
					case 0:
						let dealDate = newVal.split('-')
						this.startText = dealDate[0] + '年' + dealDate[1] + '月'
						break
					case 1:
						let obj = this.quarterList.find(
							(x) => x.quarterStartTime == newVal
						)
						this.startText = obj.year + '年' + obj.quarter + '季度'
						break
					case 2:
						this.startText = newVal + '年'
						break
				}
			},
			deep: true,
		},
		'searchObj.selectEndTime': {
			handler(newVal, oldVal) {
				this.endText = ''
				if (newVal == '') {
					return
				}
				switch (this.activeBtn) {
					case 0:
						let dealDate = newVal.split('-')
						this.endText += dealDate[0] + '年' + dealDate[1] + '月'
						break
					case 1:
						let obj = this.quarterList.find(
							(x) => x.quarterEndTime == newVal
						)
						this.endText = obj.year + '年' + obj.quarter + '季度'
						break
					case 2:
						this.endText = newVal + '年'
						break
				}
			},
			deep: true,
		},
	},
}
</script>
<style lang='less' scoped>
.FormManager-layout {
	/deep/ .el-tabs__item.is-top {
		background: linear-gradient(180deg, #ffffff 0%, #dbdcdb 100%);
		border-radius: 3px 3px 0px 0px;
		border: 1px solid #dcdcdc;
		color: #999;
	}
	/deep/ .el-tabs__item.is-active {
		color: #000 !important;
		background: #fff !important;
		font-weight: 500 !important;
		font-family: PingFangSC-Medium, PingFang SC !important;
		border: none !important;
	}
	/deep/ .el-tabs__item.is-top:hover {
		color: #409eff !important;
	}
	/deep/ .el-checkbox {
		width: 128px !important;
		margin-right: 10px !important;
	}
	.btn-flex {
		display: flex;
		.el-button {
			flex: 1;
		}
	}
}
</style>
